<!--站点下拉框-->
<template>
    <div>
        <el-select
            v-model="site"
            :multiple="isMultiple"
            clearable
            filterable
            collapse-tags
            default-first-option
            placeholder="站点"
            no-data-text="未加载出数据，请刷新页面"
            :style="{ width }"
            :size="size"
            @change="chooseSite"
            @focus="getArea"
        >
            <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                <el-option
                    v-for="item in group.children"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"
                >
                    <span style="float: left;font-size:1em">{{ item.value }}</span>
                    <el-tooltip
                        v-if="item.cec_id"
                        class="item"
                        effect="light"
                        :content="'互联互通公司：' + ConnactText(item.cec_id)"
                        placement="top"
                    >
                        <v-img
                            width="1.2em"
                            contain
                            height="1.2em"
                            style="float: right;margin-top:0.5em"
                            src="../assets/cec.svg"
                        ></v-img>
                    </el-tooltip>
                </el-option>
            </el-option-group>
        </el-select>
    </div>
</template>

<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
import Public from "@/public";
export default {
    data() {
        return {
            options: [
                // {
                //     label: '南昌市',
                //     children: [
                //         { value: '站点1', id: 4,cec_id:null },
                //         { value: '站点2', id: 5 ,cec_id:null },
                //     ],
                // },
                // {
                //     label: '九江市',
                //     children: [
                //         { value: '站点3', id: 0,cec_id:null  },
                //         { value: '站点4', id: 1,cec_id:null  },
                //         { value: '站点5', id: 2 ,cec_id:null },
                //         { value: '站点6', id: 3 ,cec_id:null },
                //         { value: '站点7', id: 108,cec_id:null  },
                //     ],
                // },
            ],
            site: null,
            isMultiple: false,
            firstSite: null,
        };
    },
    async created() {
        this.isMultiple = this.multiple;
		await this.getArea()
    },
    async mounted() {
        await this.getSite(this.siteList);
        if (!this.contactInfo) {
            await store.dispatch("getConnact", {});
        }
    },
    updated() {
        this.site = this.selectSite;
    },
    watch: {
        multiple: {
            handler(val) {
                this.isMultiple = val;
                if (val) {
                    this.site = [];
                } else {
                    this.site = null;
                }
            },
            deep: true,
        },
        site: {
            handler(val) {},
            deep: true,
        },
    },
    props: {
        size: String, //尺寸
        width: String, //宽度
        multiple: Boolean, //是否多选
        selectSite: null, //选择的站点
        isCaotact: Boolean, //是否是互联互通表单
        isAll: Boolean, //是否选择全部站点
    },
    computed: {
        ...mapState(["siteList", "contactInfo","allArea","siteInfo",]),
    },
    methods: {
		async getArea() {
		    await store.dispatch("getArea", {});
		    let areaCode = [];
		    for (let i = 0; i < this.allArea.length; i++) {
		        areaCode.push({
		            label: this.allArea[i],
		            children: [],
		        });
		    }
		    await this.getSelectSite(areaCode);
		},
		async getSelectSite(area) {
		    let areaCode = area;
		    let promiseArr = [];
		    let postDataArr = [];
			let that = this;
		    for (let i = 0; i < areaCode.length; i++) {
		        let postData = {
		            area_code: areaCode[i].label,
		            from: 0,
		            limit: 10000,
		        };
		        await store.dispatch("getSite", postData);
		        let promise = new Promise((resolve, reject) => {
		            resolve(this.siteInfo);
		        });
		        promiseArr.push(promise);
		    }
		    Promise.allSettled(promiseArr)
		        .then(result => {
		            for (let i = 0; i < result.length; i++) {
		                if (result[i].status === "fulfilled") {
		                    let data = result[i].value;
		                    for (let j = 0; j < data.length; j++) {
		                        areaCode[i].children[j] = {
		                            id: data[j].id,
		                            value: data[j].name,
		                            cec_id: data[j].cec_id,
		                            status: data[j].status
		                        };
		                    }
		                    areaCode[i].children.sort(Public.createComprisonFunction2("value"));
		                } else {
		                    util.ShowTip(result[i].status, 2);
		                }
		            }
		            areaCode.sort(Public.createComprisonFunction2("label"));
		            // store.commit("SET_SITE_LIST", areaCode);
					that.getSite(areaCode)
		        })
		        .catch(error => {
		            util.ShowTip(error, 2);
		        });
		},
        getSite(areaCode) {
			if(!areaCode) {
				return;
			}
            this.options = JSON.parse(JSON.stringify(areaCode));
            if (this.isCaotact) {
                this.options.unshift({
                    label: "",
                    children: [
                        { cec_id: null, id: -2, value: "全部站点" },
                        { cec_id: null, id: -1, value: "不共享站点" },
                    ],
                });
            }
            if (this.isAll) {
                let arr = [];
                for (let i = 0; i < this.options.length; i++) {
                    for (let j = 0; j < this.options[i].children.length; j++) {
                        if (
                            this.options[i].children[j].id != -1 &&
                            this.options[i].children[j].id != -2
                        ) {
                            arr.push(this.options[i].children[j].id);
                        }
                    }
                }
                this.site = arr;
            }
			console.log(this.options)
        },
        /*选择站点*/
        chooseSite() {
            let siteData = {};
            if (!this.isCaotact) {
                let siteId = this.JsonData(this.site);
                if (this.multiple) {
                    siteData = {
                        siteIds: [],
                    };
                    siteData.siteIds = siteId;
                } else {
                    let cec_id = null;
                    let siteName = null;
                    for (let i = 0; i < this.options.length; i++) {
                        for (let j = 0; j < this.options[i].children.length; j++) {
                            if (siteId === this.options[i].children[j].id) {
                                cec_id = this.options[i].children[j].cec_id;
                                siteName = this.options[i].children[j].value;
                            }
                        }
                    }
                    siteData = {
                        siteId: null,
                        cecId: null,
                        siteName: null,
                    };
                    siteData["siteId"] = siteId;
                    siteData["cecId"] = cec_id;
                    siteData["cecName"] = this.ConnactText(cec_id);
                    siteData["siteName"] = siteName;
                }
                this.$emit("choose", siteData);
                return;
            } else if ((this.isMultiple && this.site.includes(-1)) || this.site == -1) {
                this.isMultiple = false;
                siteData = {
                    siteId: -1,
                    cecId: null,
                    siteName: "不共享站点",
                    isSpecial: true,
                };
                this.$emit("choose", siteData);
                return;
            } else if ((this.isMultiple && this.site.includes(-2)) || this.site == -2) {
                // this.isMultiple = false;
                // siteData = {
                //     siteId: -2,
                //     cecId: null,
                //     siteName: "全部站点",
                //     isSpecial: true,
                // };
                this.isMultiple = true;
                siteData = {
                    siteIds: [],
                    isAll: true,
                };
                let arr = [];
                for (let i = 0; i < this.options.length; i++) {
                    for (let j = 0; j < this.options[i].children.length; j++) {
                        if (
                            this.options[i].children[j].id != -1 &&
                            this.options[i].children[j].id != -2
                        ) {
                            arr.push(this.options[i].children[j].id);
                        }
                    }
                }
                siteData.siteIds = arr;
                this.$emit("choose", siteData);
                return;
            } else {
                this.isMultiple = true;
                if (!this.firstSite && typeof this.site == "number") {
                    this.firstSite = this.site;
                    this.site = [];
                    this.site.push(this.firstSite);
                    this.firstSite = null;
                }
                console.log(this.site);
                let siteId = this.JsonData(this.site);
                siteData = {
                    siteIds: [],
                };
                siteData.siteIds = siteId;
                this.$emit("choose", siteData);
                return;
            }
        },
        ConnactText(cec_id) {
            let text = "";
            if (this.contactInfo != null) {
                for (let i = 0; i < this.contactInfo.length; i++) {
                    if (cec_id === this.contactInfo[i].id) {
                        text = this.contactInfo[i].name;
                    }
                }
            }
            return text;
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
